<template>
  <div>
    <table v-if="employeeReliefsHistory.length > 0" aria-label="other benefits table" class="w-full mt-6">
      <thead>
        <tr>
          <th id="0">#</th>
          <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
            <p>{{ header.title }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in employeeReliefsHistory" :key="i" class="tableBody text-sm" style="height: 48px;">
          <td>
            {{ i + 1 }}
          </td>
          <td class="capitalize">
            {{ data.name ? data.name : `----` }}
          </td>
          <td>
            {{ data.amount ? convertToCurrency(data.amount) : `----` }}
          </td>
          <td>
          {{ data.createdAt ?
              `${$DATEFORMAT(
                new Date(data.createdAt),
                "MMMM dd, yyyy"
              )}` : `----`
            }}
          </td>
          <td class="flex flex-col">
            <span class="font-semibold text-sm uppercase">
              {{ data.lastUpdatedBy ? `${data.lastUpdatedBy.fname} ${data.lastUpdatedBy.lname}` : `----`}}
            </span>
            <span class="text-xs text-blueCrayola">
              {{ data.updatedAt ? `${$DATEFORMAT(new Date(data.updatedAt), "MMMM dd, yyyy")}` : `----` }}
            </span>
          </td>
          <td>
            <span
              class="grosspay capitalize font-semibold"
              :style="{
                  backgroundColor: data.status === 'approved' ? `#13B56A14` :
                    data.status === 'disapproved' ? `#EA3C5314` :
                    data.status === 'pending' ? `#E9932314` : `#13B56A26`,
                  color: data.status === 'approved' ? `#13B56A` :
                    data.status === 'disapproved' ? `#EA3C53`:
                    data.status === 'pending' ? `#E99323` : `#13B56A`,
                }"
            >
              {{ data.status === 'pending' ? 'pending' :
                data.status === 'approved' ? 'validated' :
                data.status === 'disapproved' ? 'invalidated' : `-----`}}
            </span>
          </td>
          <td class="text-blueCrayola">
            <div v-if="data.fileName" class="flex cursor-pointer gap-1">
              <div>
                <icon icon-name="doc" size="s" class="w-5 h-5 rounded" v-if="data.fileMimeType.includes('doc')"/>
                <icon icon-name="xlsx" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('xlsx')"/>
                <icon icon-name="xlsx" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('vnd.ms-excel')"/>
                <icon icon-name="csv" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('csv')"/>
                <icon icon-name="png" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('png')"/>
                <icon icon-name="ppt" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('ppt')"/>
                <icon icon-name="pdf" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('pdf')"/>
                <icon icon-name="jpg" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('jpg')"/>
                <icon icon-name="jpg" size="s" class="w-5 h-5 rounded" v-else-if="data.fileMimeType.includes('jpeg')"/>
              </div>
              <span>
                {{  data.fileName && data.fileName.length > 12 ? data.fileName.slice(0, 12) + '...' : data.fileName }}
              </span>
            </div>
            <span v-else>----</span>
          </td>
          <td>
            <Menu left top="-150" margin="24" class="my-2 p-0">
              <template v-slot:title>
                <icon icon-name="more_icon" size="xs" />
              </template>
                <div class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2">
                  <div class="w-full" @click="viewRelief(data)">
                    <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                      <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
                      <p class="font-normal text-sm text-darkPurple">View Details</p>
                    </div>
                  </div>
                  <div class="w-full" @click="viewFile(data)">
                    <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                      <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
                      <p class="font-normal text-sm text-darkPurple">View Document</p>
                    </div>
                  </div>
                  <div class="w-full" @click.prevent="downloadFile(data.fileUrl)">
                    <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                      <Icon icon-name="download" class-name="text-flame" size="xs" />
                      <p class="font-normal text-sm text-darkPurple">Download Document</p>
                    </div>
                  </div>
                </div>
              </Menu>
          </td>
        </tr>
        <tr class="h-7" />
      </tbody>
    </table>
    <div class="flex text-jet text-sm flex-col justify-center items-center w-full p-8 m-8 gap-2" v-else>
      <img :src="require('@/assets/images/cash-bag.svg')" alt="not_found">
      <p class="font-black text-xs uppercase">
        No relief history added yet.
      </p>
    </div>

    <ViewRelief v-if="isViewRelief"
      :relief="selectedItem"
      @close="isViewRelief = false"
    />
    <ViewFile v-if="isViewFile" 
      @close="isViewFile = false" 
      :item="selectedFile" 
    />
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import ViewRelief from "@/components/ViewRelief";
import ViewFile from "@/components/documents/ViewFile";

export default {
  components: { Menu, ViewRelief, ViewFile },
  props: {
    employeeReliefsHistory: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      headers: [
        { title: "relief type" },
        { title: "Annual figure" },
        { title: "date submitted" },
        { title: "last updated" },
        { title: "status" },
        { title: "attachment" },
        { title: " " }
      ],
      isViewRelief: false,
      selectedItem: {},
      isViewFile: false,
      selectedFile: {}
    };
  },
  computed: {
  },
  methods: {
    viewRelief(data){
      this.isViewRelief = true;
      this.selectedItem = data
    },
    viewFile(data){
      this.isViewFile = true;
      this.selectedFile = data
    },
    downloadFile(fileUrl) {
      this.$downloadFile(fileUrl)
    },
  },
};
</script>

<style scoped>
.grosspay {
  background: #2176ff26;
  padding: 0.3rem 0.7rem;
  color: #2176ff;
  border-radius: 5px;
}
</style>